<template>
  <v-data-table
    class="mt-4"
    mobile-breakpoint="0"
    :items-per-page="5"
    item-key="studentCode"
    :headers="originHeaders"
    :items="priceStudent"
    :footer-props="{
      'items-per-page-text': 'Hiển thị mỗi trang',
      'items-per-page-all-text': 'Tất cả'
    }"
    disable-sort
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item.index }}
    </template>
    <template v-slot:[`item.teacher`]="{ item }">
      <div>{{ item.name }}</div>
      <div v-if="item.phone === 'Thiếu thông tin'" class="text-error">{{ item.phone }}</div>
      <div v-else>{{ item.phone }}</div>
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ item.dob }}
    </template>
    <template v-slot:[`item.gender`]="{ item }">
      {{ item.gender }}
    </template>
    <template v-slot:[`item.class`]="{ item }">
      {{ item.class }}
    </template>
    <template v-slot:[`item.price`]="{ item }">
      <div v-if="item.price === 'Lỗi dữ liệu'" class="text-error">
        {{ item.price }}
      </div>
      <div v-else>
        {{ item.price && item.price.toLocaleString('en-US') }}{{ item.type.includes('%') ? '%' : ' VND' }}
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  components: {},
  props: {
    priceStudent: Array,
    selected: Boolean
  },
  data() {
    return {
      originHeaders: [
        { text: 'STT', value: 'index' },
        { text: 'Giáo viên', value: 'teacher' },
        { text: 'Ngày sinh', value: 'dob', width: 100 },
        { text: 'Giới tính', value: 'gender' },
        { text: 'Mức chi/thu', value: 'price' },
        { text: 'Ghi chú riêng', value: 'notes' }
      ]
    }
  },
  methods: {
    getColor(status) {
      if (status === 'active' || status === 'Đang học') return '#46BE8A'
      if (status === 'Bảo lưu' || status === 'reserved') return 'orange'
      if (status === 'Đã tốt nghiệp' || status === 'graduated') return 'primary'
      if (status === 'Đã nghỉ' || status === 'left') return 'red'
      return 'grey'
    }
  }
}
</script>

<style scoped>
.text-error {
  color: #fd6b6b;
}
</style>
